/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.input`
  width: 100%;
  margin: 7px 0;
  padding: 10px;
  border-radius: 5px;
`;
